module.exports = __webpack_public_path__ + "img/3_171.aad5ffd5.png";